var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center space-x-2"},[_c('icon-clock'),_c('span',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.time)+" min")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }